module.exports = __webpack_public_path__ + "static/media/riverlake.5541aefc.png";